import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Link, useParams} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {TranslationKeys} from '../../utils/constants/routeConstants';
import {
  articleAsyncActions, getTeiArticle
} from '../../redux/pageAsyncActions';
import Loader from '../../components/loader';
import './styles.scss';

export const ArticleSummary: React.FunctionComponent = () => {
  const {
    article: {
      article
    },
    status: {
      loading
    }
  } = useSelector((state: IStore) => state);
  const dispatch = useDispatch();
  const {articleId} = useParams();
  const [summary, setSummary] = useState<string[]>([]);

  useGetTranslations({
    translationKey: TranslationKeys.Article
  });

  useEffect(() => {
    if (articleId) {
      if (!article || article.id.toString() !== articleId) {
        dispatch(articleAsyncActions[getTeiArticle](articleId));
      }
    }
  }, [articleId]);

  useEffect(() => {
    if (article && article.summary) {
      setSummary(article.generatedSummary.split(/\n+/));
    }
  }, [article]);

  return article && <div className="summary-page">
    {!article && loading.includes(getTeiArticle) && <Loader className="summary-page__loader"/>}
    <header className="summary-page__header">
      <h1><FormattedMessage
        id={'gritx.article.summary'}
        defaultMessage={'Summary'}
      /></h1>
      {article && <Link to={`/article/${article.id}`} className="summary-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to article'}
        /></Link>}
    </header>
    <main className="summary-page__container">
      <div className="summary-page__body">
        {summary.map((s, i) => {
          return <p key={i}>{s}</p>;
        })}
      </div>
    </main>
  </div>;
};
